import { getI18NMessage } from './i18nMessage';
import { setTemplate } from './template';
import { getParameterByName } from './util';
import { namespace } from '@ncui-util-common/util';

namespace('ncui.util.notSupportedIe.init');
window.ncui.util.notSupportedIe.indexInit = init;

async function init(){

  let setlang = getParameterByName('lang');
  document.documentElement.setAttribute('lang', isSupportedLang(setlang) ? setlang : 'en');

  if(setlang === 'ar'){
    document.documentElement.setAttribute('dir', 'rtl');
  }

  try {
    let data = await getI18NMessage();
    return setTemplate(data);

  } catch (err) {
    console.error(err);
  }
}

// 지원 언어가 추가되면 여기에도 추가 해주세요.
function isSupportedLang(lang){
  return ['ar', 'en','id', 'ja', 'ko', 'ru', 'th', 'zh'].includes(lang);
}












